import React, { ElementType, FC, MouseEvent, ReactElement } from 'react';
import cx from 'classnames';

import { smallStarSize } from '../constants';

import { noop } from '@buyside/util/lodashAlt';

import styles from './starStyles.scss';

const Star: FC<{
  className?: string;
  dataHeap?: string;
  fill?: string;
  fillPercentage?: number;
  height?: number;
  num: number;
  onClick?: (e: MouseEvent) => void;
  onMouseEnter?: (e: MouseEvent) => void;
  onMouseLeave?: (e: MouseEvent) => void;
  stopColor?: string;
  Tag?: ElementType;
  type: string;
  width?: number;
}> = ({
  className = '',
  dataHeap = '',
  fill = '#4990E2',
  fillPercentage = 0,
  height = smallStarSize,
  num,
  onClick = noop,
  onMouseEnter = noop,
  onMouseLeave = noop,
  stopColor = '#CCCCCC',
  Tag = 'span',
  type,
  width = smallStarSize
}): ReactElement => (
  <Tag
    data-testid={`${type}-${num}`}
    onClick={onClick}
    data-heap={dataHeap}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <svg
      viewBox="0 0 15 14"
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}px`}
      height={`${height}px`}
      className={cx(styles.star, className)}
    >
      <defs>
        <linearGradient
          x1="2.32703566%"
          y1="50%"
          x2="101.914194%"
          y2="50%"
          id={`star-${type}-${num}`}
        >
          <stop stopColor={fill} offset="0%" />
          <stop stopColor={fill} offset={`${fillPercentage}%`} />
          <stop stopColor={stopColor} offset={`${fillPercentage}%`} />
          <stop stopColor={stopColor} offset="100%" />
        </linearGradient>
      </defs>
      <g id="star" transform="translate(0, 0)" fill={`url(#star-${type}-${num})`}>
        <path
          transform="translate(0-1)"
          d="m7.347 12.239l-4.408 2.317.842-4.909-3.567-3.476 4.929-.716 2.204-4.466 2.204 4.466 4.929.716-3.566 3.476.842 4.909z"
        />
      </g>
    </svg>
  </Tag>
);

export default Star;
